import { useMutation,useQueryClient } from "react-query";
import { Api } from "src/apis/helpers/configs/api";
import { container } from "tsyringe";
import { useCallback } from "react";
import { StandardsService } from "src/apis/services/standards/standardsService";
export const useDeleteStandards = () => {
    const standardsService = container.resolve(StandardsService);
    

    const queryClient = useQueryClient();

    const toggleDeleteStandards = useCallback(
        (targetStandardsId) => {

                queryClient.removeQueries([Api.Standards.getStandards]);
            
        },
        [],
    )

    return useMutation({
        mutationFn: (standardId: number) => {
            return standardsService.deleteStandards(standardId);
        },
        onSuccess: (data, targetId, context) => {
            toggleDeleteStandards(targetId);
        }
    })
}